import { render } from "./ApprovedApplicationList.vue?vue&type=template&id=2b06542a&scoped=true"
import script from "./ApprovedApplicationList.vue?vue&type=script&lang=js"
export * from "./ApprovedApplicationList.vue?vue&type=script&lang=js"

import "./ApprovedApplicationList.vue?vue&type=style&index=0&id=2b06542a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b06542a"]])

export default __exports__